import {sortNumerically} from './sorters';

export const TableColumns = {
  id: (props) => (
    {
      title: 'Id',
      dataIndex: 'id',
      sorter: (a, b) => sortNumerically(a.id, b.id),
      defaultSortOrder: 'ascend',
      ...props,
    }
  ),
};
